import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import { fetchStaffGrade } from "../../../../features/dropdown/dropdownSlice";

const { TextArea } = Input;

const AddEngagementModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { staffGradeData, loading } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        stId: prodd?.stId ? prodd?.stId : null,
        stEngtrmcode: formData?.stEngtrmcode,
        stEngtrmname: formData?.stEngtrmname,
        url: "hr/saveStaffTerm.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchStaffGradeData() {
    dispatch(fetchStaffGrade());
  }

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit position ${prodd?.stEngtrmname}`
            : "Add position details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            label="Engagement Code"
            rules={[
              {
                required: true,
                message: "Enter engagement Code",
              },
            ]}
          >
            <Input
              required
              name="stEngtrmcode"
              onChange={onChange}
              value={formData?.stEngtrmcode}
              className="input"
            />
          </Form.Item>
          <Form.Item
            label="Engagement Name"
            rules={[
              {
                required: true,
                message: "Enter engagement name",
              },
            ]}
          >
            <Input
              required
              name="stEngtrmname"
              onChange={onChange}
              value={formData?.stEngtrmname}
              className="input"
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddEngagementModal;
